module.exports = __webpack_public_path__ + "img/buy_normal_ko.c9172ce2.png";